import { render, staticRenderFns } from "./RoleAvatar.vue?vue&type=template&id=1563e8d7"
import script from "./RoleAvatar.vue?vue&type=script&lang=js"
export * from "./RoleAvatar.vue?vue&type=script&lang=js"
import style0 from "./RoleAvatar.vue?vue&type=style&index=0&id=1563e8d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports